/**
 * Remove price from personalization labels
 */

(function() {
  'use strict';
  
  function removePricesFromPersonalizationLabels() {
    // Target all pplrlabel elements
    const labels = document.querySelectorAll('.pplrlabel');
    
    labels.forEach(function(label) {
      // Iterate through child nodes to find text nodes
      label.childNodes.forEach(function(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          // Remove price patterns like (+$19), (+$25.99), etc.
          // node.textContent = node.textContent.replace(/\s*\(\+\$[\d.]+\)/g, '');
        }
      });
    });
  }
  
  // Run on initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removePricesFromPersonalizationLabels);
  } else {
    // DOM already loaded
    removePricesFromPersonalizationLabels();
  }
  
  // Also run when new content is dynamically loaded (for AJAX/dynamic content)
  // Observer for dynamically added content
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        removePricesFromPersonalizationLabels();
      }
    });
  });
  
  // Start observing when DOM is ready
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
})();
